<template>
    <div class="input">       
        <input type="checkbox" class="input__control" :id="id"
           v-model="newValue" :value="newValue" :name="name" />
        <label :for="id" v-html="title"></label>
        <slot />       
    </div>    
</template>

<script>
    export default {
        props: {
           value: [String, Number, Boolean, Function, Object, Array, Symbol],
           nativeValue: [String, Number, Boolean, Function, Object, Array, Symbol],
           title: {
               type: String,
               default: () => ''
           },
           name: {
               type: String,
               default: () => ''
           },
           rules: {
               type: String,
               default: () => ''
           },
           id : {
               type: String
           }
        },
        data() {
            return {
                newValue: this.value
            }
        },
        methods: {
            onChange() {
               this.newValue = !this.newValue
            },            
        },
        watch: {
            value(value) {
                this.newValue = value
            },
            newValue(value) {
                this.$emit('input', value)
            }
        }     
    }
</script>